export interface AiContentVerifyDropzoneProps {
  limitsText: string;
  errorMessage: string | null;
  fileInputAccept: string;
  onFileChosen: (file: File) => void;
}

export const DROPZONE_ERROR_ID = 'ai-content-verify-dropzone-error';
